import type { UseQueryOptions } from '@tanstack/react-query';

import { useQuery as tanstackUseQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getAccessToken } from 'src/shared/utils/getAccessToken';
import { paramsSerializer } from 'src/shared/utils/paramsSerializer';

export type UseQueryProps<T> = {
  transform?: <U = T>(data: T) => Promise<T | U>;
  url: string;
  urlParams?: Record<string, unknown>;
  withAuthorization?: boolean;
} & UseQueryOptions<T>;

export const useQuery = <T>({
  queryKey,
  transform,
  url,
  urlParams,
  withAuthorization = true,
  ...options
}: UseQueryProps<T>) => {
  const query = tanstackUseQuery({
    queryFn: async () => {
      const headers: Record<string, string> = {};

      if (withAuthorization) {
        const token = getAccessToken();
        if (token) {
          headers.Authorization = `Bearer ${token}`;
        }
      }

      const { data } = await axios.get<T>(url, {
        headers,
        params: urlParams,
        paramsSerializer,
      });
      return transform ? transform(data) : data;
    },
    queryKey,
    ...options,
  });

  return { ...query };
};
